import Axios from 'axios'

var baseUrl = process.env.VUE_APP_BASEURL + ':' + process.env.VUE_APP_BASEURLPORT + "/api/boleto/";
if(process.env.NODE_ENV != 'development'){
	baseUrl = process.env.VUE_APP_BASEURL;
}

const instance = Axios.create({
	"baseURL": baseUrl,
	"timeout": 30000
});

var helper = {

	callback_error(error){
		let msg = "";
		if(typeof error.Erro != "undefined"){
			msg = error.Erro;
		}else if(typeof error.ERRO != "undefined"){
			msg = error.ERRO;
		}else{
			msg = error;
		}

		alert(msg);
	},

	axios(){
		return instance;
	},

	formatDate(valor){
		let split;

		if(typeof valor != 'undefined' && valor != ''){

			if(valor.indexOf('-') != -1){
				// quando formato no padrão americano (YYYY-MM-DD), do contrário entende-se que já vem formatado (DD/MM/YYYY)
				split = '-';
				let info = valor.split(split);

				if(info[2].length>2){
					valor = info[0] + "/" + info[1] + "/" + info[2];
				}else{
					valor = info[2] + "/" + info[1] + "/" + info[0];
				}
			}
			
			return valor;

		}else{
			return valor;
		}
	},

	formatDateMMDDYYYY(valor){
		let split;

		if(typeof valor != 'undefined' && valor != ''){

			if(valor.indexOf('/') != -1){
				// quando formato no padrão americano miva (MM/DD/YYYY) converte para o brasileiro (DD/MM/YYYY)
				split = '/';
				let info = valor.split(split);

				valor = info[1] + "/" + info[0] + "/" + info[2];
			}

			return valor;

		}else{
			return valor;
		}
	},

	formatValue(valor){
		
		let ret;

		if(typeof valor == "undefined"){
			return '';
		}

		if(valor == ''){
			valor = 0.00;
		}

		ret = parseFloat(valor);
		ret = ret.format(2, 3, '.', ',');

		return ret;
	},

	copyToClipboard(text){
		navigator.clipboard.writeText(text);
	},
}

export default helper